function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { List, Space, Button, Drawer } from "antd";
import Moment from "react-moment";
import { BoxFill } from "react-bootstrap-icons";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import DisplayPo from "./DisplayPo";
import EditPurchaseOrder from "./forms/EditPurchaseOrder";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var PurchaseOrdersList = function PurchaseOrdersList(_ref) {
  var list = _ref.list,
    refresh = _ref.refresh;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDislay = _useState2[0],
    setShowDisplay = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEdit = _useState4[0],
    setShowEdit = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedItem = _useState6[0],
    setSelectedItem = _useState6[1];
  var ref = useRef();
  var handleDelete = function handleDelete(item) {};
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {
      dataSource: list,
      itemLayout: "horizontal",
      loading: false,
      renderItem: function renderItem(item, index) {
        return /*#__PURE__*/_jsx(List.Item, {
          actions: [/*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setSelectedItem(item);
              setShowDisplay(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "OUVRIR"
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setSelectedItem(item);
              setShowEdit(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "MODIFIER"
            })
          })],
          children: /*#__PURE__*/_jsx(List.Item.Meta, {
            avatar: /*#__PURE__*/_jsx(BoxFill, {
              size: 16
            }),
            title: item.service_provider != null ? /*#__PURE__*/_jsx("b", {
              children: item.service_provider.label
            }) : /*#__PURE__*/_jsx("b", {
              children: "FOURNISSEUR INTROUVABLE"
            }),
            description: /*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Montant Total: "
                }), item.total_amount.toLocaleString("Fr")]
              }), /*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Date: "
                }), /*#__PURE__*/_jsx(Moment, {
                  date: item.created_at,
                  format: "DD/MM/YYYY"
                })]
              }), /*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Initiateur: "
                }), "".concat(item.user.prenom, " ").concat(item.user.nom)]
              })]
            })
          })
        });
      }
    }), selectedItem != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER LE BON"
        }),
        width: "80%",
        open: showEdit,
        onClose: function onClose() {
          setShowEdit(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EditPurchaseOrder, {
          po: selectedItem,
          handler: function handler() {
            refresh();
            notification.success({
              message: "Ok!",
              description: "Modifications éffectuées"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["BON DE COMMANDE N\xBA ", selectedItem.id]
        }),
        width: "80%",
        open: showDislay,
        onClose: function onClose() {
          setShowDisplay(false);
        },
        destroyOnClose: true,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref2) {
                var handlePrint = _ref2.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  onClick: handlePrint,
                  type: "ghost",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "IMPRIMER"
                  })
                });
              }
            })
          })
        }),
        children: /*#__PURE__*/_jsx(DisplayPo, {
          po: selectedItem,
          ref: ref
        })
      })]
    })]
  });
};
export default PurchaseOrdersList;